<!-- src/components/Modal.vue -->
<template>
  <div v-if="isOpen" class="modal-backdrop">
    <div class="modal-container" @click.stop>
      <div class="modal-content">
        <div class="checkbox-container">
          <div v-for="tag in localTags" :key="tag.tagId" class="checkbox-item">
            <label>
              <input type="checkbox" v-model="tag.selected" />
              {{ tag.tagName }}
            </label>
          </div>
        </div>
      </div>
      <div class="button-container">
        <button class="btn btn-primary" @click="resetSelection">戻る</button>
        <button class="btn btn-primary" @click="confirmSelection">設定</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, watch, ref } from "vue";

interface Tag {
  tagId: string;
  tagName: string;
  selected: boolean;
}

export default defineComponent({
  name: "TagsModalComponent",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    tags: {
      type: Array as PropType<Tag[]>,
      required: true,
    },
  },
  emits: ["close", "updateTags"],
  setup(props, { emit }) {
    const localTags = ref<Tag[]>([]);
    const originalTags = ref<Tag[]>([]);

    watch(
      () => props.isOpen,
      (newVal) => {
        if (newVal) {
          // モーダルが開かれたときに元の状態を保存
          originalTags.value = props.tags.map((tag) => ({ ...tag }));
          localTags.value = props.tags.map((tag) => ({ ...tag }));

          console.log("originalTags:", originalTags);
          console.log("localTags:", localTags);
        }
      }
    );

    const close = () => {
      emit("close");
    };

    const confirmSelection = () => {
      console.log("originalTags:", originalTags);
      console.log("localTags:", localTags);
      emit("updateTags", localTags.value);
      close();
    };

    const resetSelection = () => {
      localTags.value = originalTags.value.map((tag) => ({ ...tag }));
      close();
    };

    return {
      close,
      confirmSelection,
      resetSelection,
      localTags,
    };
  },
});
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-container {
  background: white;
  padding: 20px;
  border-radius: 5px;
  position: relative;
  min-height: 60%; /* モーダルの最大高さを設定 */
  max-height: 80vh; /* モーダルの最大高さを設定 */
  overflow-y: auto; /* モーダル内でスクロールを有効にする */
  display: flex;
  flex-direction: column;
  width: 80%; /* モーダルの幅を設定 */
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
}

.modal-content {
  flex: 1; /* 残りのスペースを占める */
  border-width: 0px;
  margin: 0 auto; /* 中央寄せ */
  flex-direction: column;
  display: flex;
}

.checkbox-container {
  display: flex;
  margin-top: 20px;
  margin-left: 20px;
  flex-wrap: wrap;
  justify-content: flex-start; /* 左寄せ */
  gap: 10px;
}
.checkbox-item {
  flex: 0 1 100px; /* 各チェックボックスの幅を設定 */
}
.button-container {
  display: flex;
  margin-top: 20px;
  padding: 10px;
  justify-content: flex-end; /* 左寄せ */
  align-items: flex-end;
}
button {
  margin: 0 10px; /* 上下のマージンは0、左右のマージンを10pxに設定 */
  width: 150px;
  height: 40px;
  border-radius: 1rem;
}
</style>
